
























































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetTemplatesOfInterview,
  GetInterviews,
  PostImportPatientDataFromHdr,
  PostImportPatientDataFromCdr
} from "@/request/projects";
import { Form as elForm } from "element-ui";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class ImportDataDialog extends Vue {
  @Prop()
  private center: any;
  @Prop()
  private projectId: any;
  @Prop()
  private visible: any;
  @Prop()
  private groups: any;
  private interviews: any[] = [];
  private crfs: any = [];
  private rules: any = {
    group_id: [
      { required: true, message: "分组必须选择一个", trigger: "blur" }
    ],
    interview_id: [
      { required: true, message: "访视必须选择一个", trigger: "blur" }
    ]
  };
  private info: any = {};
  private get ifVisible() {
    return this.visible ? this.visible : false;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  private visibleChange() {
    this.$emit("update:visible", this.visible);
  }
  /**
   * @description 获得所有可选的访视
   */
  private fetchAllInterviews() {
    const params: any = {
      params: {
        group_id: this.info.group_id
      }
    };
    GetInterviews(this, params).then((data: any) => {
      this.interviews = data;
      this.crfs = [];
    });
  }
  /**
   * @description 获得所有可选的CRF量表
   */
  private fetchAllCrfs() {
    const params: any = {
      params: {
        interview_id: this.info.interview_id,
        is_page: "no"
      }
    };
    GetTemplatesOfInterview(this, params).then((data: any) => {
      this.crfs = data.templates;
    });
  }
  /**
   * @description 选择一个表单
   */
  private chooseThis(crf) {
    crf.choosed = !crf.choosed;
    this.$forceUpdate();
  }
  /**
   * @description 取消
   */
  private cancel() {
    this.ifVisible = false;
  }
  /**
   * @description 导入数据
   */
  private importData() {
    (this.$refs.importForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const arr: any = [];
        this.crfs.map((crf: any) => {
          if (crf.choosed) {
            arr.push(crf.template_id);
          }
        });
        if (arr.length === 0) {
          this.$message.warning("请至少选择一个CRF量表");
          return;
        }
        const params: any = this.info;
        params.project_id = this.projectId;
        if (params.time) {
          if (params.time[0]) {
            params["开始时间"] = params.time[0];
          }
          if (params.time[1]) {
            params["结束时间"] = params.time[1];
          }
        }
        params["template_ids"] = arr;
        params["src_center"] = this.center.center;
        switch (this.center.center) {
          case "治未病数据中心":
          case "中医影像数据中心":
            PostImportPatientDataFromHdr(this, params).then(() => {
              this.$message.success("导入成功");
              this.$emit("finish");
              this.ifVisible = false;
            });
            break;
          case "临床科室数据中心":
          case "名中医传承数据中心":
            params["src_project_id"] = this.center.project_id;
            delete params["src_center"];
            PostImportPatientDataFromCdr(this, params).then(() => {
              this.$message.success("导入成功");
              this.$emit("finish");
              this.ifVisible = false;
            });
            break;
        }
      }
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$nextTick().then(() => {
      // this.fetchAllInterviewsExceptCurrentGroup();
    });
  }
}
